<template>
    <div>
        <div>
            <dispatcherNav />
            <dispatcherInfo />
        </div>

        <div class="dispatcher-map">
            <mapComponent
                :cars="activeCars"
                :calls="activeCalls"
                @map-was-initialized="initialization"
            />
        </div>
        <dispatcherNotification />
    </div>
</template>

<script>
import { bus } from '@/main';
import dispatcherInfo from '@/components/dispatcherInfo';
import dispatcherNav from '@/components/dispatcherNav';
import dispatcherNotification from '@/components/dispatcherNotification';
import preloader from '@/components/preloader';
import { mapActions, mapGetters } from 'vuex';
import mapComponent from '@/components/map';
import { filter, map } from 'lodash';
import { DISPATCHER_DATA_REQUEST_INTERVAL } from '../const/common';

export default {
    components: {
        dispatcherNav,
        dispatcherInfo,
        dispatcherNotification,
        preloader,
        mapComponent,
    },
    data: () => ({
        map: null,
        callsCollection: [],
        carsCollection: [],
        dispatcherNavRun: false,
    }),
    created() {
        //  "On Map" button
        bus.$on('launchShowOnMap', (fullname) => {
            for (
                var i = 0, len = this.callsCollection.getLength();
                i < len;
                i++
            ) {
                var placemark = this.callsCollection.get(i);
                if (
                    placemark.properties._data.balloonContentHeader === fullname
                ) {
                    this.map.setCenter(placemark.geometry.getCoordinates(), 18);
                    placemark.balloon.open();
                }
            }
        });
    },
    mounted() {
        // Инициалазиция приложения
        if (!this.soundPlayConfirmation) {
        }
    },
    destroyed() {
        clearInterval(this.fetchData);
    },
    computed: {
        ...mapGetters('dispatcher', [
            'callsList',
            'carsList',
            'soundPlayConfirmation',
        ]),
        activeCars() {
            return filter(
                this.carsList,
                (car) =>
                    car.status === 1 || car.status === 2 || car.status === 5
            );
        },
        activeCalls() {
            return map(this.callsList, ({ user }) => ({
                id: user.id,
                coords: user.last_coords.coordinates,
                name: user.fullname,
                phone: user.phone,
            }));
        },
    },
    watch: {
        soundPlayConfirmation(newValue, oldValue) {
            if (newValue === false && newValue !== oldValue) {
                // this.initialization();
            }
        },
    },
    methods: {
        ...mapActions('dispatcher', ['getCallsList', 'getCars']),
        initialization() {
            this.fetchData = setInterval(() => {
                this.getCars();
                this.getCallsList();
            }, DISPATCHER_DATA_REQUEST_INTERVAL);
        }
    },
};
</script>

<style lang="scss" scoped>
@import '@/style/global.scss';
</style>
